namespace $.$$ {
	$mol_style_define( $shm_projects_release_notes_view, {
		flex: { direction: 'column' },
		gap: $mol_gap.block,
		Audience: { maxWidth: '24rem' },
	} )
	$mol_style_attach( '$shm_projects_release_notes_view_list_markers', `
		[shm_projects_release_notes_view_content] [mol_text_list] {
			direction: ltr;
			unicode-bidi: normal;
		}
		[shm_projects_release_notes_view_content] [mol_text_list_item] {
			position: relative;
			overflow: visible;
			list-style: none;
		}
		[shm_projects_release_notes_view_content] [mol_text_list_item]::before {
			left: -1.75rem;
			margin-inline-start: 0;
			text-align: right;
		}
	` )
}
